import { cn } from "@/lib/utils";
import { AlertTriangle, CheckCircle2 } from "lucide-react";

import {
  lineRequiresMpnEntry,
  resolveInboundMpnEntryState,
  type InboundLineMpnDraftFields,
} from "./inboundReceiveMpn";
import type { InboundLineRow } from "./inboundApi";

export function InboundReceiveMpnScan(props: {
  line: InboundLineRow;
  draft: InboundLineMpnDraftFields;
}): JSX.Element | null {
  if (!lineRequiresMpnEntry(props.line)) return null;

  const state = resolveInboundMpnEntryState({ line: props.line, draft: props.draft });
  if (state !== "matched" && state !== "unknown_confirmed") return null;

  return (
    <div className="shrink-0 rounded-md border border-slate-200 bg-slate-50 p-2">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
        Manufacturer part number
      </p>
      {state === "matched" ? (
        <div className="mt-1 flex items-center gap-2 text-sm font-medium text-emerald-700">
          <CheckCircle2 className="h-4 w-4 shrink-0" aria-hidden />
          <span className="font-mono text-emerald-800">{props.draft.scanned_mpn.trim()}</span>
        </div>
      ) : null}
      {state === "unknown_confirmed" ? (
        <div className="mt-1 space-y-1">
          <p className="font-mono text-sm font-medium text-amber-900">{props.draft.scanned_mpn.trim()}</p>
          <div
            className={cn(
              "flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 p-2 text-sm text-amber-900",
            )}
          >
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
            <span>
              Unknown part. Counts will not apply to this purchase order line. Labels will print as
              UNKNOWN PART.
            </span>
          </div>
        </div>
      ) : null}
    </div>
  );
}
